import React from "react";
import { Switch } from "react-router-dom";

import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";

import ConsoleComponent from "../containers/console";
import AdminConsoleComponent from "../containers/admin/console";
import ProductListingComponent from "../containers/admin/product-listing";
import CategoryPageComponent from "../containers/category-page";
import CartPageComponent from "../containers/cart-page";
import designGuide from "../containers/designGuide";

const Index = (props) => (
  <Switch>
    <PublicRoute component={ConsoleComponent} path="/" exact />
    <PublicRoute component={AdminConsoleComponent} path="/admin" />
    <PublicRoute
      component={AdminConsoleComponent}
      path="/admin/product-listing"
    />
    <PublicRoute component={AdminConsoleComponent} path="/admin/product-view" />
    <PublicRoute component={CategoryPageComponent} path="/category" />
    <PublicRoute component={CartPageComponent} path="/cart" />
    <PublicRoute component={designGuide} path="/design-guide" />
  </Switch>
);

export default Index;
